import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import PageList from '#/modules/commonComponents/PageList';
import { can } from '#/modules/infra/auth/can';
import materialMgmtNavigate from '#/modules/infra/navigation/materialMgmtNavigate';

const MaterialMgmtPlaceholderPage = () => {
  const permissions = useSelector((state) => state.infra.permissions);
  const linkList = useMemo(
    () => materialMgmtNavigate.filter(
      (item) => !item.permission || can(permissions, item.permission),
    ),
    [permissions],
  );

  return <PageList title="物料管理" linkList={linkList} />;
};

export default MaterialMgmtPlaceholderPage;
